<template>
    <modal id="interview-tag-modal"
        v-model="showModal"
        :title="generateModalTitle('tag')"
        @submit="submitData" :loading="loading"
        :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/interview-tag`'
            @submit.prevent="submitData"
        >
            <app-form-group v-if="acceptTypes.length > 1"
                :label="$t('type')"
                type="radio"
                v-model="formData.type"
                :error-message="$errorMessage(errors, 'type')"
                :list="listTypes"
            />
            <app-form-group
                :label="$t('title')"
                :placeholder="$placeholder('title')"
                v-model="formData.title"
                :required="true"
                :error-message="$errorMessage(errors, 'title')">
            </app-form-group>
            <app-form-group
                type="textarea"
                :label="$t('remark')"
                :placeholder="$textAreaPlaceHolder('remark')"
                v-model="formData.remark"
                :required="false"
                :error-message="$errorMessage(errors, 'remark')">
            </app-form-group>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";

export default {
    name  : "InterviewTagCreateEditModal",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        acceptTypes: {
            type: Array,
            default: () => [0, 1, 2]
        }
    },
    data() {
        return {
            formData: {
                type: this.acceptTypes[0],
            },
            TENANT_BASE_URL,
            listTypes: [
                {id:0, value: this.$t('jobs') + ' & ' + this.$t('candidate')},
                {id:1, value: this.$t('jobs')},
                {id:2, value: this.$t('candidate')},
                {id:3, value: this.$t('finance')},
                {id:4, value: this.$t('attendance')},
            ].filter(type => this.acceptTypes.includes(type.id)),
        }
    },
    methods: {
        submitData() {
            this.loading = true
            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#interview-tag-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'interview-tag-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData  = response.data;
        },
    },
}
</script>

